import {
  useEffect,
  useRef,
  useState,
} from "@bpmn-io/properties-panel/preact/hooks";
import { html } from "htm/preact";
import { jwtDecode } from "jwt-decode";
import { fetchWithSession } from "lib/util/fetchWithSession.js";
import { Session } from "svelte-session-manager";


function ParametersProps({ element }) {
  const ChatIcon = `<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M10.6 15.3L16.8 9.09999L16.3 8.59999L10.6 14.3L7.74999 11.45L7.24999 11.95L10.6 15.3ZM5.79999 19.7C5.36665 19.7 5.00832 19.5583 4.72499 19.275C4.44165 18.9917 4.29999 18.6333 4.29999 18.2V5.79999C4.29999 5.36665 4.44165 5.00832 4.72499 4.72499C5.00832 4.44165 5.36665 4.29999 5.79999 4.29999H18.2C18.6333 4.29999 18.9917 4.44165 19.275 4.72499C19.5583 5.00832 19.7 5.36665 19.7 5.79999V18.2C19.7 18.6333 19.5583 18.9917 19.275 19.275C18.9917 19.5583 18.6333 19.7 18.2 19.7H5.79999ZM5.79999 19H18.2C18.4 19 18.5833 18.9167 18.75 18.75C18.9167 18.5833 19 18.4 19 18.2V5.79999C19 5.59999 18.9167 5.41665 18.75 5.24999C18.5833 5.08332 18.4 4.99999 18.2 4.99999H5.79999C5.59999 4.99999 5.41665 5.08332 5.24999 5.24999C5.08332 5.41665 4.99999 5.59999 4.99999 5.79999V18.2C4.99999 18.4 5.08332 18.5833 5.24999 18.75C5.41665 18.9167 5.59999 19 5.79999 19Z"
    fill="#1C1C20"
    fill-opacity="0.5"
  />
</svg>`;
  const [comments, setComments] = useState([]);
  const [showTextArea, setShowTextArea] = useState(false);
  const [replyMessage, setReplyMessage] = useState(null);

  const textareaRef = useRef(null);
  let session = new Session(localStorage);
  const decoded = jwtDecode(session.authorizationHeader.Authorization || "");

  let params = new URL(document.location).searchParams;
  let idprocess = params.get("idprocess");

  const fetchComments = async () => {
    try {
      const res = await fetchWithSession(
        `/api/pman/getCommentReply?folderid=${idprocess}&element=${element.id}`,
      );
      const data = await res.json();
      if (data?.status) {
        setComments(data?.data || []);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    fetchComments();
  }, [idprocess]);

  const handleCancel = () => {
    setReplyMessage(null);
    setShowTextArea(false);
  };

  const addNewComment = async (id) => {
    const textarea = textareaRef?.current;
    if (textarea) {
      const commentText = textarea.value;
      if (commentText.trim() !== "") {
        try {
          const res = await fetchWithSession(`/api/pman/addCommentReply`, {
            method: "POST",
            body: JSON.stringify({
              folderid: idprocess,
              element: element?.id,
              msg: commentText,
              parentid: id,
              username: decoded?.sub || "",
            }),
          });

          const data = await res.json();
          if (data?.status) {
            if (id) {
              const obj = comments.map((d) => {
                if (d.id === replyMessage) {
                  return {
                    ...d,
                    reply: [
                      ...d["reply"],
                      {
                        ...data.data,
                      },
                    ],
                  };
                } else {
                  return d;
                }
              });
              setComments(obj);
            } else {
              setComments([...comments, data?.data]);
            }
            setReplyMessage(null);
          }
        } catch (error) {
          console.log("error", error);
        }
        setShowTextArea(false);
      }
    }
  };

  const replyComment = (id) => {
    setReplyMessage(id);
  };

  const resolveComment = async (id, status) => {
    try {
      const res = await fetchWithSession(`/api/pman/updateCommentReply?id=${id}`, {
        method: "PATCH",
        body: JSON.stringify({
          resolve: status,
        }),
      });

      const data = await res.json();
      if (data?.status) {
        const obj = comments.map((d) => {
          if (d.id === id) {
            return {
              ...d,
              resolve: status,
            };
          } else {
            return d;
          }
        });
        setComments(obj);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  return [
    ...(comments || []).map(
      ({ msg, reply, created_on, resolve, id, username }) => {
        return html`<div id="comments-container">
          <div>
            <div
              class=${resolve ? "comment-header dull-view" : "comment-header"}
            >
              <p>${username}</p>
              <p>${formatDate(created_on)}</p>
            </div>
            <p
              class=${resolve ? "comment-message dull-view" : "comment-message"}
            >
              ${msg}
            </p>
            ${reply?.length > 0 &&
            reply.map((d) => {
              return html`<div
                class=${resolve
                  ? "reply-container dull-view"
                  : "reply-container"}
              >
                <div>
                  <span class="reply-header">${d.username}:</span>
                  <span class="reply-message">${d.msg}</span>
                </div>
                <p>${formatDate(d.created_on)}</p>
              </div>`;
            })}
            ${replyMessage === id &&
            html`
              <div class="comment-text-area">
                <textarea
                  rows="6"
                  id="comment-textarea"
                  type="text"
                  placeholder="add reply (maximum 250 characters)"
                  ref=${textareaRef}
                />
              </div>
              <div class="comment-add-btn">
                <button onclick=${handleCancel}>Cancel</button>
                <button onclick=${addNewComment.bind(this, id)}>Send</button>
              </div>
            `}
            <div class="comment-footer">
              ${resolve
                ? html`<div class="comment-solved">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.6 15.3L16.8 9.09999L16.3 8.59999L10.6 14.3L7.74999 11.45L7.24999 11.95L10.6 15.3ZM5.79999 19.7C5.36665 19.7 5.00832 19.5583 4.72499 19.275C4.44165 18.9917 4.29999 18.6333 4.29999 18.2V5.79999C4.29999 5.36665 4.44165 5.00832 4.72499 4.72499C5.00832 4.44165 5.36665 4.29999 5.79999 4.29999H18.2C18.6333 4.29999 18.9917 4.44165 19.275 4.72499C19.5583 5.00832 19.7 5.36665 19.7 5.79999V18.2C19.7 18.6333 19.5583 18.9917 19.275 19.275C18.9917 19.5583 18.6333 19.7 18.2 19.7H5.79999ZM5.79999 19H18.2C18.4 19 18.5833 18.9167 18.75 18.75C18.9167 18.5833 19 18.4 19 18.2V5.79999C19 5.59999 18.9167 5.41665 18.75 5.24999C18.5833 5.08332 18.4 4.99999 18.2 4.99999H5.79999C5.59999 4.99999 5.41665 5.08332 5.24999 5.24999C5.08332 5.41665 4.99999 5.59999 4.99999 5.79999V18.2C4.99999 18.4 5.08332 18.5833 5.24999 18.75C5.41665 18.9167 5.59999 19 5.79999 19Z"
                        fill="#1C1C20"
                        fill-opacity="0.5"
                      />
                    </svg>
                    Solved
                  </div>`
                : html`<div></div>`}
              <div class="comment-btn">
                ${resolve
                  ? html`<button
                      onclick=${resolveComment.bind(this, id, false)}
                    >
                      Unsolve
                    </button>`
                  : !(replyMessage === id) &&
                    html` <button onclick=${replyComment.bind(this, id)}>
                        Reply
                      </button>
                      <button onclick=${resolveComment.bind(this, id, true)}>
                        Resolve
                      </button>`}
              </div>
            </div>
          </div>
          <div class="comment-divider">
            <div />
          </div>
        </div>`;
      }
    ),
    showTextArea &&
      html`
        <div class="comment-text-area">
          <textarea
            rows="6"
            id="comment-textarea"
            type="text"
            placeholder="add reply (maximum 250 characters)"
            ref=${textareaRef}
          />
        </div>
        <div class="comment-add-btn">
          <button onclick=${handleCancel}>Cancel</button>
          <button onclick=${addNewComment.bind(this, null)}>Send</button>
        </div>
      `,
    !showTextArea &&
      html`<div class="comment-add-btn">
        <button onclick=${() => setShowTextArea(true)}>
          <svg
            width="18"
            height="17"
            viewBox="0 0 18 17"
            fill="white"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.35 10.05H9.05V7.05H12.05V6.35H9.05V3.35H8.35V6.35H5.35V7.05H8.35V10.05ZM0 16.2V1.5C0 1.06667 0.141667 0.708333 0.425 0.425C0.708333 0.141667 1.06667 0 1.5 0H15.9C16.3333 0 16.6917 0.141667 16.975 0.425C17.2583 0.708333 17.4 1.06667 17.4 1.5V11.9C17.4 12.3333 17.2583 12.6917 16.975 12.975C16.6917 13.2583 16.3333 13.4 15.9 13.4H2.8L0 16.2ZM2.5 12.7H15.9C16.1 12.7 16.2833 12.6167 16.45 12.45C16.6167 12.2833 16.7 12.1 16.7 11.9V1.5C16.7 1.3 16.6167 1.11667 16.45 0.95C16.2833 0.783333 16.1 0.7 15.9 0.7H1.5C1.3 0.7 1.11667 0.783333 0.95 0.95C0.783333 1.11667 0.7 1.3 0.7 1.5V14.5L2.5 12.7Z"
              fill="white"
            />
          </svg>
          Add Comment
        </button>
      </div>`,
  ];
}

export default function (element) {
  return [
    {
      id: "comments",
      element,
      component: ParametersProps,
    },
  ];
}
